import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import {
  StoreRouterConnectingModule,
  FullRouterStateSerializer,
} from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import {
  AppEffects,
  ContextMenuEffects,
  DownloadEffects,
  FavoriteEffects,
  SearchEffects,
  TemplateEffects,
} from '@adw/projects/aca-content/src/lib/store/effects';
import {
  SnackbarEffects,
  RouterEffects,
} from '@adw/projects/aca-shared/store/src/public-api';
import { environment } from '@adw/src/environments/environment';

import { appReducer } from './reducers/app.reducer';
import { INITIAL_STATE } from './states/app.state';
import { NodeFolderEffects } from './effects/node-folder.effects';
import { NodeFileActionsEffects } from './effects/node-file-actions.effects';
import { NodeCheckoutEffects } from './effects/node-checkout.effects';
import { NodeBulkOperationsEffects } from './effects/node-bulk-operations.effects';
import { NodeWorkflowEffects } from './effects/node-workflow.effects';
import { ViewerEffects } from './effects/viewer.effects';
import { CompareEffects } from './effects/compare.effects';
import { CreateDialogsEffects } from './effects/create-dialogs.effects';
import { LibraryEffects } from './effects/library.effects';
import { KeywordEffects } from './effects/keyword.effects';
import { ModalEffects } from './effects/modal.effects';
import { UploadEffects } from './effects/upload.effects';
import { FeatureFlagsEffects } from './effects/feature-flags.effects';
import { NodeEffects } from './effects/node.effects';

@NgModule({
  imports: [
    StoreModule.forRoot(
      { app: appReducer },
      {
        initialState: INITIAL_STATE,
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      }
    ),
    StoreRouterConnectingModule.forRoot({
      serializer: FullRouterStateSerializer,
      stateKey: 'router',
    }),
    EffectsModule.forRoot([
      AppEffects,
      NodeFileActionsEffects,
      NodeCheckoutEffects,
      NodeBulkOperationsEffects,
      NodeWorkflowEffects,
      CompareEffects,
      NodeFolderEffects,
      NodeEffects,
      DownloadEffects,
      ViewerEffects,
      SearchEffects,
      LibraryEffects,
      UploadEffects,
      FavoriteEffects,
      TemplateEffects,
      ContextMenuEffects,
      CreateDialogsEffects,
      KeywordEffects,
      ModalEffects,
      SnackbarEffects,
      RouterEffects,
      FeatureFlagsEffects,
    ]),
    !environment.production
      ? StoreDevtoolsModule.instrument({ maxAge: 25 })
      : [],
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppStoreModule {}
